import React from 'react'
import {
  Button,
} from 'reactstrap';
import SignerCoordinatesConfigurationModal from './modal';


export const requireSignersPosition = (resource) => {
  let hasAdvance = _.some(resource.signers, { signature_mode: "advance" });

  return resource.file && resource.file.type == 'application/pdf' && ((resource.document_information?.has_signatures && resource.require_signers) || hasAdvance);
};

export const processSignaturePosition = (props) => {
  const {
    currentX,
    currentY,
    deltaX,
    deltaY,
    width,
    height,
    pageDimensions,
    existingSignatures,
    signers = []
  } = props;

  let newX = currentX + deltaX;
  let newY = currentY + deltaY;

  newX = Math.max(0, Math.min(newX, pageDimensions.width - width));
  newY = Math.max(0, Math.min(newY, pageDimensions.height - height));

  const isColliding = (x, y) => {
    const collidesWithExisting = existingSignatures.some(signature => {
      const [sigLeft, sigBottom, sigRight, sigTop] = signature.coordinates;
      const sigWidth = sigRight - sigLeft;
      const sigHeight = sigTop - sigBottom;

      return (
        x < sigLeft + sigWidth &&
        x + width > sigLeft &&
        y < sigBottom + sigHeight &&
        y + height > sigBottom
      );
    });

    const collidesWithSigners = signers.some(signer => {
      if (_.isEmpty(signer.sign_coordinates)) { return false }

      const signerX = signer.sign_coordinates.x;
      const signerY = signer.sign_coordinates.y;

      return (
        x < signerX + width &&
        x + width > signerX &&
        y < signerY + height &&
        y + height > signerY
      );
    });

    return collidesWithExisting || collidesWithSigners;
  };

  if (isColliding(newX, newY)) {
    let adjustedX = newX;
    let adjustedY = newY;
    let foundValidPosition = false;

    for (let radius = 1; radius <= Math.max(pageDimensions.width, pageDimensions.height); radius++) {
      for (let angle = 0; angle < 360; angle += 45) {
        const radians = (angle * Math.PI) / 180;
        const candidateX = Math.round(newX + radius * Math.cos(radians));
        const candidateY = Math.round(newY + radius * Math.sin(radians));

        const boundedX = Math.max(0, Math.min(candidateX, pageDimensions.width - width));
        const boundedY = Math.max(0, Math.min(candidateY, pageDimensions.height - height));

        if (!isColliding(boundedX, boundedY)) {
          adjustedX = boundedX;
          adjustedY = boundedY;
          foundValidPosition = true;
          break;
        }
      }
      if (foundValidPosition) break;
    }

    newX = adjustedX;
    newY = adjustedY;
  }

  return { x: newX, y: newY };
};

export const drawSignersCoordinatesActionButton = ({ requireSignersPositionValue, toggleModalSignerCoordinate }) => {
  if (requireSignersPositionValue) {
    return (
      <>
        <Button
          color="primary"
          className="btn-sm my-2"
          onClick={toggleModalSignerCoordinate}
        >
          Posición de firmas
        </Button>
      </>
    );
  }
  return null;
};

export const drawSignerCoordinatesConfigurationModal = (props) => {
  const {
    requireSignersPositionModalRef,
    requireSignersPositionValue,
    modalSignerCoordinates,
    toggleModalSignerCoordinate,
    resource,
    setResource,
    disabledSubmitButton,
    onConfirm
  } = props;

  if (requireSignersPositionValue) {
    let footer;

    if (onConfirm) {
      footer = {
        buttonActions: [
          {
            label: disabledSubmitButton ? I18n.t('actions.saving') : 'Guardar y continuar',
            color: 'success',
            onClick: onConfirm,
            size: 'md',
            disabled: disabledSubmitButton
          }
        ]
      };
    } else {
      footer = requireSignersPositionModalRef?.current?.modal?.footer;
    }

    return (
      <SignerCoordinatesConfigurationModal
        modal={{
          configuration: {
            isOpen: modalSignerCoordinates,
            toggle: toggleModalSignerCoordinate
          },
          footer: footer
        }}
        resource={resource}
        callbacks={{
          setResource: setResource
        }}
      />
    );
  }
  return null;
};

